import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Section from './Section';

const SectionsList = ({
  sections,
  ...rest
}) => {
  return (
    <Fragment>
      {sections.map(section => (
        <Section
          key={section.title}
          section={section}
          {...rest}
        />
      ))}
    </Fragment>
  );
};

SectionsList.propTypes = {
  sections: PropTypes.array.isRequired,
};

export default SectionsList;



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/SectionsList.jsx